import { Dialog, DialogContent, View, Image, Button } from "@/components/ui";
import Logo from "@/assets/images/logo.png";
import { IconButton } from "@/components/ui/icon-button";
import { Divider } from "@/components/shared/divider";
import { Link } from "@/components/shared/link";
import { NavbarListItem } from "../navbar-list-item";
import { UserAvatar } from "../user-avatar";
import { useAuthState } from "@/store/auth";
import { AuthModals } from "@/types/users";
import { PosthogAnalytics } from "@/lib/monitoring/posthog";
import { GetTheAppNow } from "../get-the-app-now";
import { useAuth } from "../../auth-provider";
import { useRoute } from "@/components/shared/router";
import { Bell, Question, SignOut } from "@/components/shared/icons";
import { GenerateMenu } from "../generate-menu";
import { Fragment } from "react/jsx-runtime";
import { links } from "@/constants";
import { handleOpenLink } from "@/lib/platform/index.web";

export const NavbarMobile = ({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) => {
  const {
    data: { userInfo, unreadNotificationCount },
  } = useAuthState();
  const { isAuthenticated } = useAuth();
  const { push } = useRoute();
  const { showModal } = useAuthState();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        showClose={false}
        className="max-w-screen flex h-dvh flex-col border-0 bg-brand-static p-0"
      >
        <View className="flex h-full flex-1 flex-col py-4 font-light color-brand-on-static">
          <View className="mb-4 flex items-center justify-between px-4">
            <Image src={Logo} alt="Logo" width={60} height={28} />
            <IconButton
              variant="ghost"
              color="white"
              iconName="x"
              size="xl"
              onClick={() => setOpen(false)}
            />
          </View>

          <View className="flex flex-1 flex-col overflow-y-auto px-4">
            {isAuthenticated ? (
              <>
                <Link href="profile">
                  <NavbarListItem
                    icon={<UserAvatar />}
                    title={userInfo.firstName}
                    onClick={() => setOpen(false)}
                  />
                </Link>
                <Divider className="my-3 opacity-25" />
                <Link href="/notifications">
                  <NavbarListItem
                    icon={<Bell size={22} />}
                    badge={
                      unreadNotificationCount > 0
                        ? String(unreadNotificationCount)
                        : undefined
                    }
                    title="Notification"
                    onClick={() => setOpen(false)}
                  />
                </Link>
              </>
            ) : (
              <>
                <Divider className="mb-3 opacity-25" />
                <View className="grid grid-cols-2 gap-2">
                  <Button
                    variant="secondary"
                    size="lg"
                    rounded="full"
                    className="border border-brand-static-border"
                    onClick={() => {
                      setOpen(false);
                      push({ pageKey: "login" });
                    }}
                    children="Sign In"
                  />
                  <Button
                    variant="primary"
                    size="lg"
                    color="CTA"
                    rounded="full"
                    className="border border-transparent"
                    onClick={() => {
                      setOpen(false);
                      push({ pageKey: "signup" });
                      PosthogAnalytics.track("user_sign_up");
                    }}
                    children="Sign Up"
                  />
                </View>
              </>
            )}
            <Divider className="my-3 opacity-25" />
            <View onClick={() => setOpen(false)}>
              <GenerateMenu />
            </View>
            <Divider className="my-3 opacity-25" />
            <NavbarListItem
              icon={<Question size={22} />}
              title="Help"
              showTrailingIcon={false}
              onClick={() => {
                handleOpenLink(links.helpCenter);
              }}
            />
            {isAuthenticated ? (
              <Fragment>
                <NavbarListItem
                  icon={<SignOut size={22} />}
                  title="Logout"
                  showTrailingIcon={false}
                  onClick={() => {
                    setOpen(false);
                    showModal(AuthModals.LOGOUT);
                  }}
                />
                <Divider className="mt-3 opacity-25" />
              </Fragment>
            ) : null}
            <GetTheAppNow size="large" className="mt-auto pt-4" />
          </View>
        </View>
      </DialogContent>
    </Dialog>
  );
};
